<template>
  <div class="pageJftActive">
    <XR-head titleText="JKT激活" :rightShow="false"></XR-head>    
    <div class="total account-address">
      <p class="title">请激活您的JKT账户，激活后即可使用JKT在{{websiteName}}消费购物。</p>
      <!-- <mu-divider class="line"></mu-divider><p class="desc">由美国顶尖技术人员历时三年，采用极具创新意识的“pow+posl+evm”技术，成功研发出全球领先的第五代数字资产，Pom智能合约技术的出现，由分布式账本+分布式计算器+虚拟计算机+实体应用场景+支付系统的构想无疑是一种开拓性的创举，使得数字资产更加透明，也更加具有回溯性和零容错率，完美实现了和ETH生态的兼容性，更适合各种金融生活场景，将真实商业社会与区块链世界紧密连接！</p> -->
      <mu-raised-button label="激活" @click="submit" primary fullWidth class="activeBtn"></mu-raised-button>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    submit: function() {
      var ths = this;   
      ths.$refs.XRtoast.load("激活中...")
      ths.$post(
        "/Shop/JftServer/MakeJftAccount"
      ).then(function(res) {
        if(!res.IsSuccess){     
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{         
          ths.$refs.XRtoast.hide()
          ths.$router.goBack()
        }
      });
    }
  }
};
</script>
<style>
#app .pageJftActive{
  bottom: 0;
  background: white;
}
.pageJftActive .total{
  background: white;
  padding: 20px 20px;
}
.pageJftActive .title{
  line-height: 24px;
  font-size: 14px;
  color:red;
}
.pageJftActive .line{    
  margin: 10px 0;
}
.pageJftActive .account-address .desc{    
  padding: 10px 0 0;
  font-size: 12px;
  color:#999;
  word-break: break-all;
}
.pageJftActive .activeBtn{    
  height: 50px;
  margin: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/jft/local/jftActive.vue